module.exports = __webpack_public_path__ + "img/avatar-63.6b940d7f.png";